export default __webpack_public_path__ + "static/media/test_glasses.798ba2a6.svg";